/*
  Casa Micelio — menú principal
  Dawn convierte los ítems con submenú en <summary>: solo abren/cierran y nunca
  navegan. El sitio necesita el comportamiento anterior (clic en "Microdosis" o
  "Macrodosis" lleva a su página), así que en escritorio el submenú se abre al
  pasar el mouse y el clic queda libre para navegar.
  En táctil no se toca nada: el tap sigue abriendo el submenú, que incluye un
  enlace "Ver ..." hacia la página del padre.
*/
(function () {
  var soportaHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var limpiar = [];

  function activar() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      var enlacePadre = menu.querySelector('summary .micelio-parent-link');
      if (!details || !enlacePadre) return;

      var cierre;
      var abrir = function () {
        clearTimeout(cierre);
        details.open = true;
        var resumen = details.querySelector('summary');
        if (resumen) resumen.setAttribute('aria-expanded', 'true');
      };
      var cerrar = function () {
        cierre = setTimeout(function () {
          details.open = false;
          var resumen = details.querySelector('summary');
          if (resumen) resumen.setAttribute('aria-expanded', 'false');
        }, 150);
      };

      menu.addEventListener('mouseenter', abrir);
      menu.addEventListener('mouseleave', cerrar);
      limpiar.push(function () {
        menu.removeEventListener('mouseenter', abrir);
        menu.removeEventListener('mouseleave', cerrar);
        clearTimeout(cierre);
      });
    });
  }

  function desactivar() {
    limpiar.forEach(function (fn) { fn(); });
    limpiar = [];
  }

  function evaluar() {
    desactivar();
    if (soportaHover.matches) activar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluar);
  } else {
    evaluar();
  }
  // Cambios de tamaño/dispositivo y recargas del editor de temas
  if (soportaHover.addEventListener) {
    soportaHover.addEventListener('change', evaluar);
  } else if (soportaHover.addListener) {
    soportaHover.addListener(evaluar);
  }
  document.addEventListener('shopify:section:load', evaluar);
})();
